import { CreateAiBuilderReviewRequest } from '@activepieces/shared';

import { api } from '@/lib/api';

export const AiBuilderReviewApi = {
  send: (request: CreateAiBuilderReviewRequest) => {
    return api.post<void>('/v1/ai-builder-review', request);
  },
};
